import Application from "../../Application";
import ReportingTypePresenter, {
  IReportingTypePresenter
} from "../../presenter/reporting/ReportingTypePresenter";
import GetReportingTypeInteractor from "./GetReportingTypeInteractor";
import GetFormTypesGroupCategoriesInteractor from "../formconfiguration/GetFormTypesGroupCategoriesInteractor";

export default class ShowReportingTypesInteractor {
  private application: Application;
  private output?: IReportingTypePresenter;

  constructor(application) {
    this.application = application;
  }

  async getReportingType() {
    return this.application.container
      .resolve<GetReportingTypeInteractor>("getReportingTypes")
      .execute();
  }

  async getFormTypesGroupCategories() {
    return this.application.container
      .resolve<GetFormTypesGroupCategoriesInteractor>(
        "getFormTypesGroupCategories"
      )
      .execute();
  }

  async getData() {
    const reportingTypes = await this.application.container
      .resolve<GetReportingTypeInteractor>("getReportingTypes")
      .execute();
    const formTypesGroupCategories = await this.application.container
      .resolve<GetFormTypesGroupCategoriesInteractor>(
        "getFormTypesGroupCategories"
      )
      .execute();

    return { reportingTypes, formTypesGroupCategories };
  }

  execute() {
    this.output = ReportingTypePresenter({
      application: this.application,
      initialState: {
        reportingTypes: [],
        formTypesGroupCategories: []
      }
    });

    this.getData().then(result =>
      this.output?.load(result.reportingTypes, result.formTypesGroupCategories)
    );

    return this.output;
  }
}
